import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import './footer.scss';

const Footer = props => {
  useEffect(() => {
    if (!window.MHD || !window.MHD.UI.Navigation) return;

    // resize the footer bar to not overlap side nav
    window.MHD.UI.Navigation.handleFullPageFooterWidth();
  }, []);

  return (
    <footer className="mhd--page-footer">
      <div className="pull-left">{props.leftside}</div>
      <div className="pull-right">{props.rightside}</div>
    </footer>
  );
};

Footer.defaultProps = {
  leftside: null,
  rightside: null,
};

Footer.propTypes = {
  leftside: PropTypes.array,
  rightside: PropTypes.array,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/Footer.js